import type { AvatarSlots as AvatarBaseSlots, AvatarBaseProps, AvatarBaseState } from '@fluentui/react-avatar';

/**
 * Avatar component slots
 */
export type AvatarSlots = AvatarBaseSlots;

/**
 * Avatar component props
 */
export type AvatarProps = AvatarBaseProps;

/**
 * Avatar component state
 */
export type AvatarState = AvatarBaseState;
